import React from "react";
import { Link } from "react-router-dom";
import * as IoIcons from "react-icons/tb";

import styles from "./styles/return.module.css";

function About({ data }) {
  const companyPath =
    data.company.IdType === 1
      ? `company/${data.company.Slug}`
      : data.company.IdType === 2
      ? `obrazovanie-v-bashkortostane/vuzy-rb/${data.company.Slug}`
      : data.company.IdType === 4
      ? `obrazovanie-v-bashkortostane/shkoly-rb/${data.company.Slug}`
      : `obrazovanie-v-bashkortostane/kolledzhi-rb/${data.company.Slug}`;

  return (
    <div className={styles.block}>
      <div className={`container ${styles.second}`}>
        <Link to={`/${companyPath}`} className={styles.link}>
          <IoIcons.TbArrowLeft style={{ marginRight: 5 }} />
          {data.company.IdType === 1 ? "К компании" : "К учреждению"}
        </Link>
      </div>
    </div>
  );
}

export default About;
